import MUILinearProgress, {
  LinearProgressProps as MUILinearProgressProps,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

interface LinearProgressProps extends Omit<MUILinearProgressProps, 'color'> {
  color?: 'primary' | 'secondary' | 'orange' | 'yellow' | 'green' | 'red';
}

interface StyledLinearProgressProps {
  $progressColor: 'primary' | 'secondary' | 'orange' | 'yellow' | 'green' | 'red';
}

const colorMap = {
  orange: '#FABEAB',
  red: (theme: any) => theme.palette.error.main,
  yellow: '#FFDD76',
  green: '#00C389',
  primary: (theme: any) => theme.palette.primary.main,
  secondary: (theme: any) => theme.palette.secondary.main,
};

const StyledLinearProgress = styled(MUILinearProgress, {
  shouldForwardProp: (prop) => prop !== '$progressColor',
})<StyledLinearProgressProps>(({ theme, $progressColor }) => {
  const getBarColor = () => {
    const color = colorMap[$progressColor];
    return typeof color === 'function' ? color(theme) : color;
  };

  return {
    backgroundColor: theme.palette.grey[200],
    '& .MuiLinearProgress-bar': {
      backgroundColor: getBarColor(),
    },
  };
});

export const LinearProgress: FC<LinearProgressProps> = ({ color = 'primary', ...props }) => {
  return <StyledLinearProgress $progressColor={color} color="primary" {...props} />;
};
